// A simple knowledge base for the AI agent to explain key terms.

export const knowledgeBase = {
  'safety score': {
    title: 'Safety Score',
    explanation:
      'The Safety Score is a comprehensive metric from 0-100 that represents the overall safety performance of a jobsite or company. It combines leading indicators like training completion and hazard reporting with lagging indicators like incident rates.',
    related: ['incident rate', 'compliance rate'],
  },
  'incident rate': {
    title: 'Incident Rate',
    explanation:
      'The Incident Rate measures the number of safety incidents (accidents, injuries, near-misses) per a standard number of work hours (e.g., per 100 workers per week). A lower rate is better.',
    related: ['safety score', 'OSHA recordables'],
  },
  'compliance rate': {
    title: 'Compliance Rate',
    explanation:
      'The Compliance Rate tracks the percentage of completed and signed-off compliance items, such as safety checklists, permits, and worker certifications. A higher rate indicates better adherence to safety protocols.',
    related: ['worker certifications', 'safety score'],
  },
  'worker engagement': {
    title: 'Worker Engagement',
    explanation:
      'Worker Engagement measures how actively your workforce is participating in safety programs. It includes metrics like toolbox talk attendance, hazard reporting, and submitting safety suggestions. High engagement is a strong leading indicator of a positive safety culture.',
    related: ['safety culture', 'leading indicators'],
  },
  'safety roi': {
    title: 'Safety ROI (Return on Investment)',
    explanation:
      "Safety ROI calculates the financial return on your safety investments. It compares the costs of your safety program (e.g., training, PPE) to the savings from prevented incidents (e.g., reduced insurance premiums, fewer lost workdays). A value greater than 1.0x means you're saving more than you're spending.",
    related: ['cost of incidents', 'financial metrics'],
  },
  'leading indicators': {
    title: 'Leading Indicators',
    explanation:
      'Leading indicators are proactive safety metrics that measure efforts to prevent incidents *before* they happen. Examples include safety training completion, hazard observations, and safety meeting attendance. They are predictive of future safety performance.',
    related: ['lagging indicators', 'worker engagement'],
  },
  'lagging indicators': {
    title: 'Lagging Indicators',
    explanation:
      "Lagging indicators are reactive safety metrics that measure failures after they have occurred, such as the number of incidents or injuries. While useful for tracking past performance, they don't predict future outcomes. The goal of a strong safety program is to improve leading indicators to reduce lagging indicators.",
    related: ['leading indicators', 'incident rate'],
  },
};

export const lookupTerm = (term) => {
  const lowerTerm = term.toLowerCase().trim();
  const exactMatch = Object.keys(knowledgeBase).find((key) => key === lowerTerm);
  if (exactMatch) return knowledgeBase[exactMatch];

  const partialMatch = Object.keys(knowledgeBase).find((key) => key.includes(lowerTerm));
  if (partialMatch) return knowledgeBase[partialMatch];

  return null;
};
